import { memo, useContext, useEffect, useState } from 'react';
import CollapsibleArea, {
    CollapsibleAreaContext,
} from '../../../../../components/CollapsibleArea';
import { TabsContext } from '../../../../../components/Tabs';
import { RiskModelType } from '../../../../../context/createASpool/createASpoolType';
import useIsMounted from '../../../../../hooks/useIsMounted';
import useSpoolsByRiskModel from '../../../../../hooks/web3/app/useSpoolsByRiskModel';
import SpoolsByRiskModelTable from './SpoolsByRiskModelTable';

type Props = {
    riskModel: RiskModelType;
};

const SpoolsByRiskModel: React.FC<Props> = ({ riskModel }) => {
    const { updateHeight } = useContext(TabsContext);

    const { updateCollapsedHeight } = useContext(CollapsibleAreaContext);

    const [collapsed, setCollapsed] = useState(false);

    const [disabled, setDisabled] = useState(false);

    const { address } = riskModel;

    const { isLoading } = useSpoolsByRiskModel(address);

    const isMounted = useIsMounted();

    const toggleMoreDetails = () => {
        if (disabled) return;

        setCollapsed((prev) => !prev);
        setDisabled(true);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            isMounted() && setDisabled(false);
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [collapsed, isMounted]);

    useEffect(() => {
        updateHeight();

        const interval = setInterval(() => {
            if (isMounted()) {
                updateCollapsedHeight();
            }
        }, 100);

        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, 600);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [collapsed, isLoading, isMounted, updateCollapsedHeight, updateHeight]);

    return (
        <div className='more-details-container'>
            <div
                className={`more-details-trigger ${collapsed ? 'collapsed' : ''}`}
                onClick={toggleMoreDetails}
            >
                <div className='arrow-container'>
                    <div className='arrow' />
                </div>
                <span>{collapsed ? 'Hide' : 'Show'} Spools that use this Risk Model</span>
                <div className='line' />
            </div>
            <CollapsibleArea
                className={`spools ${isLoading && 'loading'}`}
                collapsed={collapsed}
            >
                <SpoolsByRiskModelTable riskModel={riskModel} />
            </CollapsibleArea>
        </div>
    );
};

export default memo(SpoolsByRiskModel);
